import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable } from "@angular/core";


import { PAGES,API } from '../../shared/constants';
import {UserService} from '../../shared/user.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let user = JSON.parse(this.userService.getUser());
    if(user == null || user == undefined){
      this.router.navigate(['/login']);
      return false;
    }else{
      for(let i in PAGES){
        if(PAGES[i].link.indexOf(state.url) >= 0){
          if(PAGES[i].roles.indexOf(user.role) >= 0){
            return true;
          }
        }
      }
      this.router.navigate([user.landPage]);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/auth.guard.ts